import { Wrapper, StyledTitle, StyledContent } from "./Info.styled";

interface Props {
  title: string
  content: string
}

export const Info = (props: Props) => {
  return (
    <Wrapper>
      <StyledTitle>{props.title}</StyledTitle>
      <StyledContent>{props.content}</StyledContent>
    </Wrapper>
  );
};